/**
 * Medallón de laurel — segunda familia de sello de línea fina, distinta del
 * matasellos postal (PostalStamp): ese habla de correo/tiempo (temporada,
 * confirmación de pedido); este habla de certificación/mérito (grado
 * alimenticio, antigüedad de la marca). Dos motivos coherentes entre sí
 * (mismo trazo, mismo color) pero con significado propio, en vez de reusar
 * un solo ícono para todo.
 *
 * La rama se dibuja una sola vez (tallo + hojas como líneas cortas, mismo
 * recurso que sheetLines en PaperBale.js) y se refleja con un <g> espejado
 * para la rama derecha — nunca se duplican las coordenadas a mano.
 */
export default function LaurelSeal({ children, className = '', color = 'var(--kraft-deep)' }) {
    const stemD = 'M50,90 C34,88 22,76 20,58 C19,44 24,32 34,24';
    const leaves = [
        [46, 87, 36, 92],
        [38, 80, 26, 82],
        [30, 70, 18, 69],
        [22, 58, 10, 55],
        [23, 46, 12, 40],
        [28, 35, 18, 26],
        [35, 26, 27, 16],
    ];

    const branch = (
        <>
            <path d={stemD} stroke={color} strokeWidth="1.75" fill="none" strokeLinecap="round" />
            {leaves.map(([x1, y1, x2, y2], i) => (
                <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="2" strokeLinecap="round" />
            ))}
        </>
    );

    return (
        <svg viewBox="0 0 120 120" className={className} fill="none" aria-hidden="true">
            <circle cx="60" cy="50" r="32" stroke={color} strokeWidth="2" opacity="0.55" />
            <g>{branch}</g>
            {/* Rama derecha: la misma rama, espejada en x=60 — sin repetir coordenadas */}
            <g transform="translate(120,0) scale(-1,1)">{branch}</g>
            {/* Listón que cruza abajo, cerrando la corona */}
            <path d="M44,87 Q60,96 76,87" stroke={color} strokeWidth="1.75" fill="none" strokeLinecap="round" />

            <g transform="translate(60,50)">{children}</g>
        </svg>
    );
}
